export default reportData => {
  if (!reportData) {
    return 0;
  }
  const rows = reportData.rows;

  return rows.reduce((totalCount, row) => {
    const editedCellsInRow = Object.keys(row).filter(columnKey => row[columnKey].edited).length;

    return editedCellsInRow + totalCount;
  }, 0);
};
